module.exports = __webpack_public_path__ + "img/authorize.ce7c9236.png";